/* eslint-disable default-case */
/* eslint-disable no-param-reassign */
import produce from 'immer';
import { startOfMonth, endOfMonth, subMonths } from 'date-fns';
import {
  financialReportGetLaborEfficiency,
  financialReportSetDateRange,
  financialReportSetStudios,
} from './actions';

// Finance figures are submitted per whole calendar month, so the report opens
// on the most recent month whose books are closed. On the 1st, last month has
// only just ended and has nothing filed yet, so step back one more.
const defaultMonth = () =>
  subMonths(new Date(), new Date().getDate() === 1 ? 2 : 1);

const initialState = {
  dateRange: {
    startDate: startOfMonth(defaultMonth()),
    endDate: endOfMonth(defaultMonth()),
  },
  studioIds: [],
  laborEfficiency: null,
  loading: false,
  error: null,
};

const reducer = produce((draft, { type, payload }) => {
  switch (type) {
    case financialReportSetDateRange.toString():
      draft.dateRange = payload;
      break;
    case financialReportSetStudios.toString():
      draft.studioIds = payload;
      break;
    // The figures on screen belong to the period that was applied, so drop them
    // when a new request starts rather than showing them under new filters.
    case financialReportGetLaborEfficiency.REQUEST:
      draft.loading = true;
      draft.error = null;
      draft.laborEfficiency = null;
      break;
    case financialReportGetLaborEfficiency.SUCCESS:
      draft.laborEfficiency = payload;
      draft.error = null;
      break;
    case financialReportGetLaborEfficiency.FAILURE:
      draft.error = payload;
      draft.laborEfficiency = null;
      break;
    case financialReportGetLaborEfficiency.FULFILL:
      draft.loading = false;
      break;
  }
}, initialState);

export default reducer;
